import Checkbox from '@ingka/checkbox';
import FormField from '@ingka/form-field';
import InputField from '@ingka/input-field';
import { translate } from '@repo/phrase';
import { type AssetType, assetTypes } from '@repo/types/asset';

import type { ShareOption } from '@/components/share/share-options';

import { getAppConfig } from '@/utils/window.utils.ts';

import styles from './styles.module.scss';

interface Props {
    email: ShareOption;
    setEmail: (email: ShareOption) => void;
    shouldValidate: boolean;
    assetType: AssetType;
}
export const EmailShareOption = ({ email, setEmail, shouldValidate, assetType }: Props) => {
    const config = getAppConfig();

    if (!config.shareOptions.emailEnabledFor.includes(assetType)) {
        return null;
    }

    if (assetType === assetTypes.draft && !config.feature.enableCustomerMessagingDraftEmailSharing) {
        return null;
    }

    return (
        <div className={styles.form_group} data-testid="email-share-option">
            <Checkbox
                id="email-check"
                data-testid="email-check"
                name={translate('share_option_email')}
                aria-label={translate('share_option_email')}
                value="email"
                subtle
                checked={email.checked}
                onChange={() => {
                    setEmail({ ...email, checked: !email.checked });
                }}
            />
            <FormField
                className={String(styles.form_field)}
                shouldValidate={email.checked && shouldValidate}
                valid={Boolean(email.value) && email.value !== ''}
                validation={{
                    msg: translate('form_field_msg_required_field'),
                    id: 'error',
                    type: 'error',
                }}
            >
                <InputField
                    id="emailInput"
                    type="text"
                    label={translate('share_option_email')}
                    describedById={translate('share_option_email')}
                    name={translate('share_option_email')}
                    aria-label={translate('share_option_email')}
                    value={email.value ?? ''}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                        setEmail({ ...email, value: e.target.value });
                    }}
                    disabled={!email.checked}
                />
            </FormField>
        </div>
    );
};
